"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalDeclineOnMtaBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var portal_core_1 = require("@ferry/portal-core");
var RenewalDeclineOnMtaBanner = /** @class */ (function (_super) {
    __extends(RenewalDeclineOnMtaBanner, _super);
    function RenewalDeclineOnMtaBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenewalDeclineOnMtaBanner.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(portal_core_1.WarningBanner, { wording: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Due to this change, if you continue you won't be able to renew at the end of your policy. You can make this change now (you'll be covered until your policy end date) or cancel the changes to allow the policy to renew." }) }));
    };
    return RenewalDeclineOnMtaBanner;
}(React.Component));
exports.RenewalDeclineOnMtaBanner = RenewalDeclineOnMtaBanner;
//# sourceMappingURL=RenewalDeclineOnMtaBanner.js.map